export const CAREERS_DEPARTMENTS = [
  'sala',
  'bancone',
  'bar',
  'cucina',
  'brace',
  'hostess',
  'lavapiatti',
  'magazzino',
  'pulizie',
  'management',
  'altro',
] as const;

export type CareersDepartment = (typeof CAREERS_DEPARTMENTS)[number];

export const MAX_CV_SIZE_BYTES = 5 * 1024 * 1024;
export const ACCEPTED_CV_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
] as const;

export type CareersApplicationPayload = {
  firstName: string;
  lastName: string;
  phone: string;
  role: string;
  department: CareersDepartment;
  cv: File;
};

export class CareersFormError extends Error {
  constructor(
    message: string,
    public readonly code: 'not_configured' | 'network' | 'server' | 'validation',
  ) {
    super(message);
    this.name = 'CareersFormError';
  }
}

const DEFAULT_CAREERS_ENDPOINT = '/api/careers';

export async function submitCareersApplication(payload: CareersApplicationPayload): Promise<void> {
  const endpoint =
    import.meta.env.VITE_CAREERS_FORM_ENDPOINT?.trim() || DEFAULT_CAREERS_ENDPOINT;

  const body = new FormData();
  body.append('firstName', payload.firstName);
  body.append('lastName', payload.lastName);
  body.append('phone', payload.phone);
  body.append('role', payload.role);
  body.append('department', payload.department);
  body.append('cv', payload.cv, payload.cv.name);

  let response: Response;
  try {
    response = await fetch(endpoint, {
      method: 'POST',
      body,
    });
  } catch {
    throw new CareersFormError('Network error while submitting application.', 'network');
  }

  if (!response.ok) {
    throw new CareersFormError(`Server responded with status ${response.status}.`, 'server');
  }
}
